import axios from "../utils/axiosUtils";
const URL = "/agri/web";

const login = params => axios.POST(URL + "/admin/login", params);
const checkList = params => axios.POST(URL + "/goods/ratify", params);
const updateStatus = params => axios.POST(URL + "/goods/updateStatus", params);

export { login, checkList, updateStatus };



// WEBPACK FOOTER //
// ./src/views/api/api.js